export const quizNavigationBlockerExcludePaths: string[] = ['/quizzes/:id/attempt/:attemptId/result'];
